import { Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import "./../tug/testModuleInfoPage.scss";
import gaitAndBalance from "../../../../assets/images/gaitAndBalance.png";
import forwardArrow from "../../../../assets/images/forwardArrow.svg";
import viewReport from "../../../../assets/images/viewReport.svg";
import UserDetailsHeader from "../../UserDetailsHeader";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HOW_TO_TEST_GAIT_AND_BALANCE } from "../../../../routes/routerPath";
import { getParams, searchParams } from "../../../../utlis/helpers";
import { setVideoFile } from "../../../../state/actions/videoUploadAction";
import { infoPageItem } from "../../../../utlis/constants";
import FileUpload from "../videoSaved/FileUpload";
import { pageLocale } from "../../../../utlis/locale";

const GaitAndBalance = () => {
  const videoRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showItem, setShowItem] = useState(true);
  const storedTest = JSON.parse(sessionStorage.getItem("testMModule"));
  const getTestDetails = storedTest.find((e) => e.moduleId === 2);
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const { how_to_test, view_report, record_upload } = pageLocale("testinfo");
  const { testUploadAlert } = pageLocale("common");
  const itemList = [...infoPageItem];
  if (getTestDetails?.isReportAvailable) {
    itemList.splice(1, 0, {
      icon: viewReport,
      title: view_report,
    });
  }
  const { accessToken, providerId, adminId, clientId } = getParams();
  const videoHandler = (title) => {
    if (title === how_to_test) {
      navigate(HOW_TO_TEST_GAIT_AND_BALANCE + `${searchParams}`);
    }
    if (title === view_report) {
      window.location.href = `${getTestDetails?.reportURL}&isWebsite=true&accessToken=${accessToken}&providerId=${providerId}&adminId=${adminId}&clientId=${clientId}`;
    }
  };

  const videoPickHandler = () => {
    sessionStorage.setItem("fromUpload", JSON.stringify(getTestDetails));
    videoRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(setVideoFile(file));
      setShowItem(false);
    }
  };

  return (
    <UserDetailsHeader>
      {showItem ? (
        <div className="tug-test-info-wrapper">
          <Typography className="title">{getInfo?.moduleName}</Typography>
          <div className="tug-module-box">
            <div className="tug-module-subbox">
              <img src={gaitAndBalance} alt="tug-side" className="test-img" />
              <Typography className="test-description">
                {getInfo?.description}
              </Typography>
              {itemList.map((item, index) => {
                return (
                  <div
                    className="item-wrapper"
                    key={index}
                    onClick={() => videoHandler(item?.title)}
                  >
                    <div className="item-name">
                      <img src={item.icon} alt="info" className="img" />
                      <Typography>{item.title}</Typography>
                    </div>
                    <div className="arrow">
                      <img src={forwardArrow} alt="forwardArrow" />
                    </div>
                  </div>
                );
              })}
              <input
                type="file"
                accept="video/mp4"
                ref={videoRef}
                className="video-upload"
                onChange={handleFileChange}
              />
              <div className="important-text">
                <Typography
                  className="sub-info"
                  component="div"
                  dangerouslySetInnerHTML={{ __html: testUploadAlert }}
                />
              </div>
              <div className="record-upload-btn">
                <button className="button" onClick={() => videoPickHandler()}>
                  {record_upload}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <FileUpload />
      )}
    </UserDetailsHeader>
  );
};

export default GaitAndBalance;
